module.exports = __webpack_public_path__ + "static/img/rm_brand_img_luyiweisha_details.455b1ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_img_luyiweisha_details.png
// module id = Xfkz
// module chunks = 1